import React, { useEffect } from 'react';
import Text from '../../ui/Text';
import CustomBetRecommendationItem from './CustomBetRecommendationItem';
import Wrapper from '../../ui/Wrapper';
import CustomBetService from '../../utils/CustomBetService';
import ArrowMy from 'images/icons/arrow-right-slider.svg';
import BetBuilderSkeleton from '../../components/SkeletonUI/BetBuilderSkeleton/BetBuilderSkeleton';
import { detectMobile } from '../../utils/UiHelper';
import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import '@egjs/react-flicking/dist/flicking.css';
import { Arrow } from '@egjs/flicking-plugins';
// if you have to support IE9
import 'css/CustomBetRecommendation/CustomBetRecommendation.scss';
// Or, if you have to support IE9
import '@egjs/react-flicking/dist/flicking-inline.css';
import { trackEvents } from '../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATIONS,
    VAIX_TRACKING_TYPE,
} from '../../constants/vaix/VaixTrcakingConstants';
import { ScrollingAreaWrapper } from '../../ui/ScrollingArea/styled';
import {
    getOddsForBetRecommendations,
    getVaixData,
    prepareDataForCBROdds,
} from './helper';

const CustomBetRecommendation = ({ auth, isEventPage = false, eventId }) => {
    const [betRecommendation, setBetRecommendation] = React.useState([]);
    const [
        betRecommendationWithOdds,
        setBetRecommendationWithOdds,
    ] = React.useState([]);
    const [panelPerView, setPanelPerView] = React.useState(3.2);
    const [isOddsFetched, setIsOddsFetched] = React.useState(false);
    const [isHiddenPrev, setIsHiddenPrev] = React.useState(true);
    const [isHiddenNext, setIsHiddenNext] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [getEventsPending, setGetEventsPending] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [amountOfEvents, setAmountOfEvents] = React.useState(0);
    const Slider = React.useRef(null);
    let updateDataInterval = null;

    useEffect(
        () => {
            if (!auth.loginPending && !getEventsPending) {
                getEvents();
            }
        },
        [auth?.user?.userId, auth.loginPending]
    );

    useEffect(
        () => {
            if (betRecommendation.length > 0 && !getEventsPending) {
                getOdds(prepareDataForCBROdds(betRecommendation));
            }
        },
        [getEventsPending]
    );

    const updateData = () => {
        updateDataInterval = setInterval(getEvents, 30000);
    };

    useEffect(() => {
        updateData();
        return () => {
            clearInterval(updateDataInterval);
            updateDataInterval = null;
        };
    }, []);

    const getEvents = () => {
        if (!getEventsPending) {
            setGetEventsPending(true);
            let location = isEventPage
                ? VAIX_TRACKING_LOCATIONS.betBuilderEventPage
                : VAIX_TRACKING_LOCATIONS.betBuilderHomePage;

            CustomBetService.getEventsCustomBetRecommendation(
                eventId || 0,
                location,
                isEventPage
            )
                .then((res) => {
                    const { data } = res;
                    if (res.success && data.length > 0) {
                        const { data } = res;
                        let filteredEvents = data
                            .map((recItem) => ({
                                ...recItem,
                                recommendations: recItem.recommendations.filter(
                                    (item) => item.items.length > 0
                                ),
                            }))
                            .filter(
                                (recItem) => recItem.recommendations.length > 0
                            );

                        let amount = 0;
                        filteredEvents.map((item) => {
                            amount += item.recommendations.length;
                        });
                        setAmountOfEvents(amount);
                        let eventsIds = [];
                        filteredEvents.map((item) => {
                            eventsIds.push({ id: item.uof });
                        });
                        trackEvents(
                            eventsIds,
                            VAIX_TRACKING_TYPE.impressions,
                            location,
                            isEventPage ? '/sport/kamp' : '/sport/',
                            auth?.user?.userId || 0,
                            0,
                            0,
                            true
                        );
                        setBetRecommendation(filteredEvents);
                        setGetEventsPending(false);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        setError(true);
                    }
                })
                .catch((error) => {
                    setGetEventsPending(false);
                    setLoading(false);
                    setError(true);
                });
        }
    };

    const getOdds = (data) => {
        CustomBetService.getOddsCustomBetRecommendation(data).then((res) => {
            const { recommendations } = res.data;
            const recWithOdds = getOddsForBetRecommendations(
                betRecommendation,
                recommendations
            );
            setBetRecommendationWithOdds(recWithOdds);
            setIsOddsFetched(true);
        });
    };

    const getSlides = () => {
        let rec =
            betRecommendationWithOdds.length > 0
                ? betRecommendationWithOdds
                : betRecommendation;

        return rec.map((item, iteration) => {
            return item.recommendations.map((recommendation, index) => {
                let vaixData = getVaixData(recommendation);
                let eventName = `${item.homeTeam} - ${item.awayTeam}`;
                return (
                    <div
                        key={`${index}_${item.eventId}`}
                        className={'cb-rec-item-wrapper'}
                    >
                        <CustomBetRecommendationItem
                            betRecommendation={recommendation}
                            eventName={eventName}
                            vaixEventId={vaixData.vaixEventId}
                            vaixExternalEventId={vaixData.vaixExternalEventId}
                            concatedEvents={vaixData.concatedEvents}
                            isEventPage={isEventPage}
                            group={item.group}
                            competition={item.competition}
                            userId={auth?.user?.userId || 0}
                            position={iteration + 1}
                            selections={vaixData.selections}
                            kickoff={item.kickoff}
                            isOddsFetched={isOddsFetched}
                        />
                    </div>
                );
            });
        });
    };

    const plugins = [new Arrow()];

    const handleResize = (width) => {
        if (width > 800) {
            setPanelPerView(isEventPage ? 2.2 : 3.2);
            return isEventPage ? 2.2 : 3.2;
        } else if (width < 800 && width > 550) {
            setPanelPerView(isEventPage ? 1.2 : 2.2);
            return isEventPage ? 1.2 : 2.2;
        } else if (width < 550 && width > 320) {
            setPanelPerView(1.2);
            return 1.2;
        }
    };

    const handleOnReadyItem = (e) => {
        let _items = handleResize(
            document.getElementById('customBetRecommendation').offsetWidth
        );
        //add it to handle state when amount of events === panelPerView to hide next button
        handleOnChange(e, true, _items);
    };

    const handleOnChange = (e, initial, initialItems) => {
        if (initial || e.index === 0) {
            setIsHiddenPrev(true);
        } else {
            setIsHiddenPrev(false);
        }
        if (
            initial
                ? Math.round(initialItems) === amountOfEvents ||
                  amountOfEvents === 1
                : Math.round(e.index + panelPerView) === amountOfEvents
        ) {
            setIsHiddenNext(true);
        } else {
            setIsHiddenNext(false);
        }
    };

    return (
        <>
            {loading ? (
                <BetBuilderSkeleton
                    key={'skeleton'}
                    isEventPage={isEventPage}
                />
            ) : betRecommendation.length > 0 ? (
                <Wrapper
                    id={'customBetRecommendation'}
                    margin={isEventPage ? '16px 0 ' : '0 0 20px '}
                    padding={'0'}
                    width={'100%'}
                    boxSizing={'border-box'}
                    overflow={'hidden'}
                >
                    <>
                        {!isEventPage && (
                            <Text
                                margin={'0 0 8px'}
                                padding={detectMobile() ? '0 0 0 16px' : '0'}
                                size={detectMobile() ? '16' : '20'}
                                lh={detectMobile() ? '24' : '30'}
                                weight={'700'}
                                color={'1e1e1e'}
                            >
                                Anbefalede byg væddemål
                            </Text>
                        )}
                        {detectMobile() ? (
                            <ScrollingAreaWrapper>
                                {getSlides()}
                            </ScrollingAreaWrapper>
                        ) : (
                            <div className="cb-recommendation slider-container">
                                <Flicking
                                    align={{ camera: '0', panel: '0' }}
                                    circularFallback={'linear'}
                                    circular={false}
                                    duration={400}
                                    panelsPerView={panelPerView}
                                    moveType={['strict']}
                                    bound={true}
                                    adaptive={false}
                                    inputType={['touch', 'mouse', 'pointer']}
                                    preventClickOnDrag={true}
                                    onReady={(e) => {
                                        handleOnReadyItem(e);
                                    }}
                                    onAfterResize={(e) => {
                                        handleResize(e.width);
                                    }}
                                    onChanged={(e) => {
                                        handleOnChange(e);
                                    }}
                                    plugins={plugins}
                                    ref={Slider}
                                >
                                    {getSlides()}
                                    <ViewportSlot>
                                        <button
                                            className={`flicking-arrow flicking-arrow-prev ${isHiddenPrev &&
                                                'hidden'}`}
                                        >
                                            <img src={ArrowMy} alt="" />
                                        </button>

                                        <button
                                            className={`flicking-arrow flicking-arrow-next ${isHiddenNext &&
                                                'hidden'}`}
                                        >
                                            <img src={ArrowMy} alt="" />
                                        </button>
                                    </ViewportSlot>
                                </Flicking>
                            </div>
                        )}
                    </>
                </Wrapper>
            ) : null}
        </>
    );
};

export default CustomBetRecommendation;
